import React, { memo } from 'react';
import { getCartAemAuthorableDetails } from '../utils/helper';
import './CartShimmer.scss';
import { AUTHORABLE_FALLBACK, CART_AEM_CONFIG_VALUES } from '../utils/constants';

const CartShimmer = () => {

    const cartGenericProperties = JSON.parse(
        getCartAemAuthorableDetails(CART_AEM_CONFIG_VALUES.GENERIC_PROPERTIES) || '{}'
    );

    return (
        <div className="cart-shimmer">
            <h1 className="block-cart-title block-cart-title-shimmer">{cartGenericProperties?.title || AUTHORABLE_FALLBACK?.cartTitle}</h1>
            <h5 aria-label="Rentals in the cart">{cartGenericProperties?.rentalTitle || AUTHORABLE_FALLBACK?.rentalTitle}</h5>
            <div className="cart-shimmer__desktop">
                <div className="cart-shimmer-container">
                    <div className="cart-shimmer-item">
                        <div className="cart-shimmer-img shimmer-cart"></div>
                        <div className="cart-shimmer-innerContainer">
                            <div className="cart-shimmer-center">
                                <div className="cart-shimmer-name shimmer-cart"></div>
                                <div className="cart-shimmer-price shimmer-cart"></div>
                            </div>
                            <div className="cartShimmerQuatntity shimmer-cart"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cart-shimmer__mobile">
                <div className="cart-shimmer-container">
                    <div className="cart-shimmer-item">
                        <div className="mobile-cart-shimmer">
                            <div className="cart-shimmer-img-section">
                                <div className="cart-shimmer-img shimmer-cart"></div>
                            </div>
                            <div className="cart-shimmer-data-section">
                                <div className="cart-shimmer-name-mobile shimmer-cart"></div>
                                <div className="cart-shimmer-mobile-cartCounter shimmer-cart"></div>
                                <div className="cart-shimmer-name-mobile shimmer-cart"></div>
                                <div className="cart-shimmer-price-mobile shimmer-cart"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(CartShimmer);
